import { IndicadoresSearch } from "../components/buscador/Search.jsx";
const IndicadoresFrom = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{ textAlign: "center", fontSize: '29px' }}>Gestor de Indicadores</h1>

      <IndicadoresSearch />
    </div>
  );
};

export default IndicadoresFrom;
